import { collection, query, where, getDocs, onSnapshot } from 'firebase/firestore';
import { db } from '../config/firebase';

// Prompt #451 (read-exposure fix): applications reads are now gated to the
// applicant or the owning employer, and Firestore rules are not filters — a
// jobId-only query can't be proven to return only the caller's docs and is
// rejected outright. Constraining on employerId makes it provable.
export const getJobApplications = (jobId, employerId, callback) => {
  const q = query(
    collection(db, 'applications'),
    where('jobId', '==', jobId),
    where('employerId', '==', employerId)
  );
  
  return onSnapshot(q, (snapshot) => {
    const applications = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      createdAt: doc.data().createdAt
    }));
    callback(applications);
  });
};

export const getJobApplicationsOnce = async (jobId, employerId) => {
  try {
    const q = query(
      collection(db, 'applications'),
      where('jobId', '==', jobId),
      where('employerId', '==', employerId)
    );
    const snapshot = await getDocs(q);
    return snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data(),
      createdAt: doc.data().createdAt
    }));
  } catch (error) {
    console.error('Error getting job applications:', error);
    throw error;
  }
};

export const getEmployerApplications = (employerId, callback) => {
  const q = query(
    collection(db, 'applications'),
    where('employerId', '==', employerId)
  );
  
  return onSnapshot(q, (snapshot) => {
    const applications = snapshot.docs.map(doc => ({
      id: doc.id,
      ...doc.data()
    }));
    callback(applications);
  });
};